import { useInfiniteQuery } from '@tanstack/react-query';
import apiClient from '@/lib/axios';
import { useMapStore } from '@/stores/mapStore';
import { STORIES_PAGE_SIZE } from '@/lib/constants';
import { useAuth } from '@/components/auth/AuthContext';

export function useCatalystFeed() {
  const { isAuthenticated } = useAuth();
  const mapBounds = useMapStore((s) => s.mapBounds);
  const dateRange = useMapStore((s) => s.dateRange);

  return useInfiniteQuery({
    queryKey: ['catalystFeed', mapBounds, dateRange],
    queryFn: async ({ pageParam = 0, signal }) => {
      const { data } = await apiClient.get('/api/catalysts/feed', {
        params: {
          page: pageParam,
          per_page: STORIES_PAGE_SIZE,
          start_date: dateRange.start,
          end_date: dateRange.end,
        },
        signal,
      });
      // Response: { data: Catalyst[], pagination: { page, per_page, total, total_pages, has_more } }
      return {
        items: data.data ?? [],
        total: data.pagination?.total ?? 0,
        page: data.pagination?.page ?? 0,
        pages: data.pagination?.total_pages ?? 1,
      };
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.pages - 1 ? lastPage.page + 1 : undefined,
    staleTime: 60_000,
    enabled: isAuthenticated,
  });
}
